import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import VeiculoFormFields from '../components/VeiculoFormFields';
import { formatarEnderecoCompleto } from '../utils/cep';
import toast from 'react-hot-toast';

const veiculoVazio = () => ({ placa: '', marca: '', modelo: '', ano: '', cor: '', km: 0, combustivel: 'flex' });

export default function ClienteDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente] = useState(null);
  const [veiculos, setVeiculos] = useState([]);
  const [modalVeiculo, setModalVeiculo] = useState(false);
  const [veiculo, setVeiculo] = useState(veiculoVazio());
  const [editandoVeiculo, setEditandoVeiculo] = useState(null);
  const [loading, setLoading] = useState(false);

  const carregar = async () => {
    const [c, v] = await Promise.all([api.get(`/clientes/${id}`), api.get(`/clientes/${id}/veiculos`)]);
    setCliente(c.data); setVeiculos(v.data);
  };
  useEffect(() => { carregar(); }, [id]);

  const abrirNovoVeiculo = () => { setEditandoVeiculo(null); setVeiculo(veiculoVazio()); setModalVeiculo(true); };
  const abrirEditarVeiculo = v => { setEditandoVeiculo(v._id); setVeiculo({ placa: v.placa, marca: v.marca, modelo: v.modelo, ano: v.ano, cor: v.cor || '', km: v.km || 0, combustivel: v.combustivel }); setModalVeiculo(true); };

  const salvarVeiculo = async e => {
    e.preventDefault();
    if (!veiculo.marca || !veiculo.modelo) return toast.error('Selecione marca e modelo');
    setLoading(true);
    try {
      if (editandoVeiculo) {
        await api.put(`/veiculos/${editandoVeiculo}`, veiculo);
        toast.success('Veículo atualizado');
        setModalVeiculo(false);
        carregar();
      } else {
        const { data: novoVeiculo } = await api.post(`/clientes/${id}/veiculos`, veiculo);
        toast.success('Veículo cadastrado! Abrindo checkin...');
        // Cria OS mínima e redireciona para o checkin
        const { data: novaOS } = await api.post('/servicos', {
          clienteId: id,
          veiculoId: novoVeiculo._id,
          kmEntrada: veiculo.km || 0,
          status: 'orcamento',
          pecas: [],
          maosDeObra: [],
          desconto: 0,
        });
        navigate(`/checkin/${novaOS._id}`);
      }
    } catch { toast.error('Erro ao salvar veículo'); }
    finally { setLoading(false); }
  };

  const whatsapp = () => {
    const num = cliente.telefone.replace(/\D/g, '');
    window.open(`https://wa.me/55${num}?text=${encodeURIComponent(`Olá ${cliente.nome}, tudo bem? Entrando em contato da oficina.`)}`, '_blank');
  };

  if (!cliente) return <div className="flex items-center justify-center h-64 text-gray-500">Carregando...</div>;

  return (
    <div className="max-w-3xl mx-auto">
      <button onClick={() => navigate('/clientes')} className="text-blue-600 text-sm mb-4 hover:underline">← Voltar</button>
      <div className="bg-white rounded-xl shadow-sm p-5 mb-4">
        <div className="flex items-start justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">{cliente.nome}</h1>
            <p className="text-gray-500 mt-1">{cliente.telefone}</p>
            {cliente.cpf && <p className="text-gray-400 text-sm">CPF: {cliente.cpf}</p>}
            {cliente.email && <p className="text-gray-400 text-sm">{cliente.email}</p>}
            {formatarEnderecoCompleto(cliente) && <p className="text-gray-400 text-sm">{formatarEnderecoCompleto(cliente)}</p>}
          </div>
          <button onClick={whatsapp} className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 text-sm font-medium">📱 WhatsApp</button>
        </div>
      </div>

      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold text-gray-800">Veículos ({veiculos.length})</h2>
        <button onClick={abrirNovoVeiculo} className="bg-blue-600 text-white px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-blue-700">+ Adicionar</button>
      </div>
      <div className="space-y-3">
        {veiculos.length === 0 && <div className="bg-white rounded-xl shadow-sm p-8 text-center text-gray-400">Nenhum veículo cadastrado</div>}
        {veiculos.map(v => (
          <div key={v._id} className="bg-white rounded-xl shadow-sm p-4">
            <div className="flex items-start justify-between mb-3">
              <div>
                <div className="font-bold text-gray-800 text-lg">{v.placa || '(sem placa)'}</div>
                <div className="text-gray-600">{v.marca} {v.modelo} {v.ano}</div>
                <div className="text-sm text-gray-400">{v.cor} • {v.combustivel} • {Number(v.km).toLocaleString()} km</div>
              </div>
              <button onClick={() => abrirEditarVeiculo(v)} className="text-blue-600 text-sm px-2 py-1 rounded hover:bg-blue-50">Editar</button>
            </div>
            <div className="flex gap-2">
              <button onClick={() => navigate(`/servicos/novo?veiculoId=${v._id}&clienteId=${id}`)} className="flex-1 bg-blue-600 text-white py-2 rounded-lg text-sm font-medium hover:bg-blue-700">+ Novo Serviço</button>
              <button onClick={() => navigate(`/historico/${v._id}`)} className="flex-1 border border-gray-300 text-gray-700 py-2 rounded-lg text-sm font-medium hover:bg-gray-50">📋 Histórico</button>
            </div>
          </div>
        ))}
      </div>

      {modalVeiculo && (
        <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-xl max-h-[93vh] flex flex-col">
            <div className="p-5 border-b border-gray-100 flex items-center justify-between flex-shrink-0">
              <h2 className="text-lg font-semibold">{editandoVeiculo ? 'Editar Veículo' : 'Novo Veículo'}</h2>
              <button type="button" onClick={() => setModalVeiculo(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">×</button>
            </div>
            <form onSubmit={salvarVeiculo} className="overflow-y-auto flex-1 p-5">
              <VeiculoFormFields value={veiculo} onChange={setVeiculo} />
              <div className="flex gap-3 pt-5">
                <button type="button" onClick={() => setModalVeiculo(false)} className="flex-1 border border-gray-300 text-gray-700 py-2.5 rounded-lg font-medium hover:bg-gray-50">Cancelar</button>
                <button type="submit" disabled={loading} className="flex-1 bg-blue-600 text-white py-2.5 rounded-lg font-medium hover:bg-blue-700 disabled:opacity-50">{loading ? 'Salvando...' : 'Salvar'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
